module.exports = __webpack_public_path__ + "img/formulaEle.9929ce90.svg";